import React from 'react'
import './performanceTab.css'
import OrdersListTab from '../OrdersListTab/OrdersListTab'
import { useDashboardData } from '../../../Context/DashboardContext/dashboardContext';


export default function PerformanceTab({is_header,dateTime,device,url,score,class_name}) {
    return(
        <div className={`performance_tab ${is_header ? "header":""}`}>
            <div className='time'>
                <p>{dateTime}</p>
            </div>
            <div  className='device'>
                <p style={{textTransform:"capitalize"}} >{device}</p>
            </div>
            <div className='url'>
                <p>{url}</p>
            </div>
            <div className='score'>
                {is_header ? <></> : <span className={class_name}></span>}
                <p>{score}</p>
            </div>
        </div>
    )
}